/* eslint-disable consistent-return */
/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
/* eslint-disable no-use-before-define */
import { cloneDeep, find, findIndex, isArray, isEmpty, remove, uniqBy } from 'lodash';
import moment from 'moment';

import * as clubApis from '../api/clubsApi';
import * as rostersApi from '../api/rostersApi';
import {
    removeClubBannerPhoto,
    removeClubProfilePhoto,
    removeClubSponsorLogo,
    submitClubBannerCrop,
    submitClubProfilePhotoCrop,
    submitClubSponsorLogo,
    submitClubSponsorLogoCrop,
} from '../api/uploadApi';
import { ClubTierTypes, getClubEventComparatorParams, hasCurrentSeasonStarted, isFlexLeagueClubV2, isTeamTennisClub } from '../utils/clubs';
import { comparator } from '../utils/comparator';
import { getClassYearStatus, isValidClassYearId } from '../utils/constants';
import { EventHsTypes } from '../utils/eventConstants';
import { filterMembers } from '../utils/members';
import { getRostersApiAxiosInstance } from '../utils/network';
import { isNewRosterModelEnabled } from '../utils/statsig';
import { COMPONENT_CONFIG_RESET } from './actionTypes/component-config-action-types';
import ActionTypes from './actionTypes/index';
import { fetchComponentConfig } from './component-config-actions';
import { showErrorPopup, showSuccessToast } from './notification-actions';

const _ = { isEmpty, findIndex, find, cloneDeep, isArray, remove, uniqBy };
const {
    CLUBS_FETCH_HIGHSCHOOL_STANDINGS_SEASONS,
    CLUBS_FETCH_HIGHSCHOOL_STANDINGS_SEASONS_SUCCESS,
    CLUBS_FETCH_HIGHSCHOOL_STANDINGS_SEASONS_FAILURE,
    CLUBS_FETCH_HIGHSCHOOL_STANDINGS,
    CLUBS_FETCH_HIGHSCHOOL_STANDINGS_SUCCESS,
    CLUBS_FETCH_HIGHSCHOOL_STANDINGS_FAILURE,
    CLUB_ADD_UPDATE_PLAYER_ON_ROSTER,
    CLUB_ADD_UPDATE_PLAYER_ON_ROSTER_SUCCESS,
    CLUB_ADD_UPDATE_PLAYER_ON_ROSTER_FAILURE,
    CLUB_REMOVE_PLAYER_FROM_ROSTER,
    CLUB_REMOVE_PLAYER_FROM_ROSTER_SUCCESS,
    CLUB_REMOVE_PLAYER_FROM_ROSTER_FAILURE,
    CLUB_REMOVE_PLAYER_FROM_ROSTER_OPTIMISTIC,
    CLUB_SET_PLAYER_REDSHIRT_STATUS,
    CLUB_SET_PLAYER_REDSHIRT_STATUS_SUCCESS,
    CLUB_SET_PLAYER_REDSHIRT_STATUS_FAILURE,
    CLUB_UPDATE_PLAYER_REDSHIRT_STATUS_IN_ROSTER,
} = ActionTypes;

const validateRosterApiResponse = (response, dispatch, failureAction) => {
    if (response?.data?.success === false) {
        dispatch({ type: failureAction });

        if (!response?.data?.message) {
            // No message available - redirect to error page
            window.location.href = '/error';
            throw new Error('API error without message');
        }

        dispatch(showErrorPopup({ message: response.data.message }));
        throw new Error(response.data.message);
    }
    return true;
};

export const createClub = (values, addressGoogle) => async (dispatch, getState, { mainApi }) => {
    const { user } = getState().auth;
    dispatch({ type: 'CLUBS:CREATE' });
    return clubApis.createClub(mainApi, values, addressGoogle)
        .then(async (result) => {
            const { data } = result;
            if (data.isError) {
                dispatch({ type: 'CLUBS:CREATE_FAILURE' });
            } else {
                try {
                    const inviteResult = await clubApis.inviteMembersToClub(mainApi, data.id, filterMembers(values.membersList, user.id));
                    dispatch({ type: 'CLUBS:INVITE_CLUB_MEMBERS' });
                    const inviteData = inviteResult.data;
                    if (inviteData.error) {
                        dispatch({ type: 'CLUBS:INVITE_CLUB_MEMBERS_FAILURE', data: { membersInvited: false } });
                    } else {
                        dispatch({ type: 'CLUBS:INVITE_CLUB_MEMBERS_SUCCESS', data: { data: inviteData, membersInvited: true } });
                    }
                } catch {
                    // Invite failure shouldn't prevent club creation from completing; surface via Redux state, not throw.
                    dispatch({ type: 'CLUBS:INVITE_CLUB_MEMBERS_FAILURE', data: { membersInvited: false } });
                }
                dispatch({ type: 'CLUBS:CREATE_SUCCESS', data });
                if (values.isPro) {
                    dispatch({ type: 'CLUBS:CREATE_PRO_SUCCESS' });
                } else {
                    dispatch({ type: 'CLUBS:CREATE_PERSONAL_SUCCESS' });
                }
            }
        })
        .catch((err) => {
            dispatch({ type: 'CLUBS:CREATE_FAILURE' });
            throw err;
        });
};

export const createClubFromHighSchool = (schoolId, clubSubTypeId) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: 'CLUBS:CREATE' });
    return clubApis.createClubFromHighSchool(mainApi, schoolId, clubSubTypeId)
        .then((result) => {
            const { data } = result;
            if (data.isError) {
                dispatch({ type: 'CLUBS:CREATE_FAILURE', errorMessage: data.displayMessage });
            } else {
                dispatch({ type: 'CLUBS:CREATE_SUCCESS', data });
            }
        })
        .catch((err) => {
            dispatch({ type: 'CLUBS:CREATE_FAILURE', errorMessage: err.response?.data?.displayMessage });
            throw err;
        });
};

export const updateClub = (values) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: 'CLUBS:UPDATE' });
    return clubApis.updateClub(mainApi, values)
        .then((result) => {
            const { data } = result;
            if (data.isError) {
                dispatch({ type: 'CLUBS:UPDATE_FAILURE' });
            } else {
                dispatch({ type: 'CLUBS:UPDATE_SUCCESS', data });
                dispatch(getClubDetails());
            }
        })
        .catch((err) => {
            dispatch({ type: 'CLUBS:UPDATE_FAILURE' });
            throw err;
        });
};

export const getClubDetailsOnly = () => async (dispatch, getState, { mainApi }) => {
    const { clubId } = getState().club;
    dispatch({ type: 'CLUBS:GET_CLUB_DETAILS', clubId });
    const result = await clubApis.getClub(mainApi, clubId);
    const { data } = result;
    if (data.error) {
        dispatch({ type: 'CLUBS:GET_CLUB_DETAILS_FAILURE' });
    } else {
        const clubDetails = data;
        clubDetails.tmsEvents = clubDetails.recentEvents.concat(clubDetails.upcomingEvents);
        dispatch({ type: 'CLUBS:GET_CLUB_DETAILS_SUCESS', data: clubDetails });
    }
};

export function getClubDetails(isCalledInProfile) {
    return (dispatch, getState, { mainApi }) => {
        const { clubId } = getState().club;
        const { user } = getState().auth;
        if (isCalledInProfile) {
            dispatch({
                type: 'SPLASH_SHOW_LOADING',
                title: 'Loading',
                description: 'Please wait while we\'re loading your profile',
            });
        }
        dispatch({ type: 'CLUBS:GET_CLUB_DETAILS', clubId });
        clubApis.getClub(mainApi, clubId)
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'CLUBS:GET_CLUB_DETAILS_FAILURE' });
                    if (isCalledInProfile) {
                        dispatch({ type: 'SPLASH_HIDE' });
                    }
                } else {
                    const clubDetails = data;
                    clubDetails.tmsEvents = clubDetails.recentEvents.concat(clubDetails.upcomingEvents);
                    dispatch({ type: 'CLUBS:GET_CLUB_DETAILS_SUCESS', data: clubDetails });
                    if (isCalledInProfile) {
                        dispatch({ type: 'SPLASH_HIDE' });
                    }
                    if (user) {
                        if (isCalledInProfile && clubDetails.tierType.isHighSchool && clubDetails.officialHsEventCount !== 0) {
                            dispatch(getClubEventsList(null, EventHsTypes.OFFICIAL, 0, 5, true));
                        }
                        dispatch(getClubOrganizers(clubId));
                        dispatch(getClubTeamRating(clubId));

                        // Note: getClubSchoolDetails is now called by the component with feature flag check
                        // to avoid loading old data first and then updating (which causes flash)
                        // The component (ClubProfilePage) handles this in componentDidMount/componentWillReceiveProps
                        const isAdultTeamTennisClub = isTeamTennisClub(clubDetails.tierType);
                        if (isCalledInProfile && isAdultTeamTennisClub) {
                            dispatch(getAdultTeamTennisEvents({ clubId }));
                            dispatch(getAdultTeamTennisClubRoster({ clubId }));
                            dispatch(getClubResults(true));
                        }
                        const canPostScores = (data?.tierType && !_.isEmpty(data.tierType)) ? data.tierType.canPostScores : false;
                        const isCollegeClub = clubDetails?.tierType?.id === ClubTierTypes.PRO_COLLEGE || clubDetails?.tierType?.id === ClubTierTypes.FREE_COLLEGE;

                        // To fetch results for free and pro college clubs as post score will be hidden on these clubs
                        // but results of dual matches need to show there
                        // As PER FLX-325
                        if (isCalledInProfile && (canPostScores || isCollegeClub || isFlexLeagueClubV2(clubDetails?.tierType?.id))) {
                            dispatch(getClubResults(true));
                        }
                    }
                }
            })
            .catch((err) => {
                const errorData = {
                    message: err?.response?.data,
                    statusCode: err?.response?.status,
                };
                dispatch({
                    type: 'CLUBS:GET_CLUB_DETAILS_FAILURE',
                    error: errorData,
                });
                if (isCalledInProfile) {
                    dispatch({ type: 'SPLASH_HIDE' });
                }
            });
    };
}

export const setClubId = (clubId, isCalledInProfile) => async (dispatch) => {
    dispatch({ type: 'CLUBS:SET_CLUB_ID', clubId });
    if (isCalledInProfile) {
        dispatch({ type: COMPONENT_CONFIG_RESET, data: { component: 'club-profile' } });
        dispatch(fetchComponentConfig('club-profile', { clubId }));
    }
    dispatch(getClubDetails(isCalledInProfile));
};

function getEventsStartOffset(clubDetails, tmsEventsFetchState, initialFetch, hsEventType, eventStart) {
    if (clubDetails.tierType.isHighSchool) {
        if (hsEventType === EventHsTypes.OFFICIAL) {
            return eventStart === 0 ? eventStart : tmsEventsFetchState.officialHsEventsFetched;
        }
        if (hsEventType === EventHsTypes.OTHER) {
            return eventStart === 0 ? eventStart : tmsEventsFetchState.otherHsEventsFetched;
        }
        return 0;
    }
    if (initialFetch) {
        return 0;
    }
    return tmsEventsFetchState.eventsNextStart != null ? tmsEventsFetchState.eventsNextStart : tmsEventsFetchState.eventsFetched;
}

function buildEventsSuccessPayload(data, start, eventsCount, clubDetails) {
    data.forEach((event) => {
        event.momentStartDate = moment(event.eventSchedule.eventStartUtc);
        event.momentEndDate = moment(event.eventSchedule.eventEndUtc);
    });
    const now = moment();

    const recent = data.filter(event => event.momentEndDate < now);
    const upcoming = data.filter(event => event.momentEndDate >= now);
    // Dedup by id for all club types: /events/list may return events already in the initial
    // club details load (since eventsNextStart starts from the contiguous block boundary).
    // Previously _.uniqBy was only applied to upcoming for HS clubs.
    const tmsEventsRecent = _.uniqBy(clubDetails.tmsEventsRecent.concat(recent), 'id').sort(comparator(getClubEventComparatorParams(true)));
    const tmsEventsUpcoming = _.uniqBy(clubDetails.tmsEventsUpcoming.concat(upcoming), 'id').sort(comparator(getClubEventComparatorParams(false)));
    const { isHighSchool } = clubDetails.tierType;
    const allEvents = tmsEventsRecent.concat(tmsEventsUpcoming);

    return {
        tmsEventsRecent,
        tmsEventsUpcoming,
        eventsFetched: allEvents.filter(e => (isHighSchool ? e : e.published === true)).length,
        eventsNextStart: start + data.length,
        eventsListExhausted: data.length < eventsCount,
        officialHsEventsFetched: isHighSchool ? allEvents.filter(e => e.hsEventType.id === EventHsTypes.OFFICIAL).length : 0,
        otherHsEventsFetched: isHighSchool ? allEvents.filter(e => (e.published === true) && e.hsEventType.id === EventHsTypes.OTHER).length : 0,
    };
}

export function getClubEventsList(initialFetch, hsEventType, eventStart, eventCount, includeUnpublishedEvents) {
    return (dispatch, getState, { mainApi }) => {
        const { clubId, tmsEventsFetchState, clubDetails } = getState().club;
        const start = getEventsStartOffset(clubDetails, tmsEventsFetchState, initialFetch, hsEventType, eventStart);
        const eventsCount = eventCount || tmsEventsFetchState.count;
        const totalEventsCount = clubDetails.tmsEventsCount + clubDetails.demoEventCount;
        if (start >= totalEventsCount || (!initialFetch && tmsEventsFetchState.eventsListExhausted)) {
            return;
        }
        dispatch({ type: 'CLUBS:GET_CLUB_EVENTS' });
        clubApis.getClubEventsList(mainApi, clubId, start, eventsCount, hsEventType, includeUnpublishedEvents)
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'CLUBS:GET_CLUB_EVENTS_FAILURE' });
                } else {
                    dispatch({
                        type: 'CLUBS:GET_CLUB_EVENTS_SUCESS',
                        data: buildEventsSuccessPayload(data, start, eventsCount, clubDetails),
                    });
                }
            })
            .catch(() => {
                dispatch({ type: 'CLUBS:GET_CLUB_EVENTS_FAILURE' });
            });
    };
}

export function getClubDraftEventsList(initialFetch, hsEventType, eventStart, eventCount) {
    return (dispatch, getState, { mainApi }) => {
        const { clubId, tmsEventsFetchState, clubDetails } = getState().club;
        let draftEventsStart;
        if (clubDetails.tierType.isHighSchool && hsEventType === EventHsTypes.OTHER) {
            draftEventsStart = eventStart === 0 ? eventStart : tmsEventsFetchState.otherHsDraftEventsFetched;
        } else {
            draftEventsStart = initialFetch ? 0 : tmsEventsFetchState.draftEventsFetched;
        }
        const { count } = tmsEventsFetchState;
        const eventsCount = eventCount || count;
        if (draftEventsStart >= clubDetails.draftEventsCount) {
            return;
        }
        dispatch({
            type: 'CLUBS:GET_CLUB_EVENTS',
        });
        clubApis.getClubDraftEventsList(mainApi, clubId, draftEventsStart, eventsCount, hsEventType)
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'CLUBS:GET_DRAFT_CLUB_EVENTS_FAILURE' });
                } else {
                    data.forEach((event) => {
                        event.momentStartDate = moment(event.eventSchedule.eventStartUtc);
                        event.momentEndDate = moment(event.eventSchedule.eventEndUtc);
                    });

                    const draftEvents = clubDetails.draftEvents.concat(data);
                    dispatch({
                        type: 'CLUBS:GET_DRAFT_CLUB_EVENTS_SUCESS',
                        data: {
                            draftEvents,
                            otherHsDraftEventsFetched: clubDetails.tierType.isHighSchool ? draftEvents.filter(e => e.hsEventType.id === EventHsTypes.OTHER).length : 0,
                        },
                    });
                }
            })
            .catch(() => {
                dispatch({
                    type: 'CLUBS:GET_DRAFT_CLUB_EVENTS_FAILURE',
                });
            });
    };
}

export function getAllClubs() {
    return (dispatch, getState, { mainApi }) => {
        dispatch({ type: 'CLUBS:GET_ALL_CLUBS' });
        clubApis.getAllClubs(mainApi)
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({
                        type: 'CLUBS:GET_ALL_CLUBS_FAILURE',
                    });
                } else {
                    data.sort((a, b) => {
                        if (a.name < b.name) {
                            return -1;
                        }

                        if (a.name > b.name) {
                            return 1;
                        }

                        return 0;
                    });
                    dispatch({ type: 'CLUBS:GET_ALL_CLUBS_SUCCESS', data });
                }
            })
            .catch(() => {
                dispatch({
                    type: 'CLUBS:GET_ALL_CLUBS_FAILURE',
                });
            });
    };
}

export const addMembersToClub = (membersList, addingAdmins) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({
            type: 'SPLASH_SHOW_LOADING',
            title: 'Loading',
            description: 'Please wait',
        });
        const { clubId } = getState().club;
        dispatch({ type: 'CLUBS:ADD_CLUB_MEMBERS' });
        const result = await clubApis.addAdminsToClub(mainApi, clubId, membersList);
        const { data } = result;
        if (data.error) {
            dispatch({ type: 'CLUBS:ADD_CLUB_MEMBERS_FAILURE' });
            throw new Error('adding members failed');
        }
        dispatch({ type: 'CLUBS:ADD_CLUB_MEMBERS_SUCCESS', data: { data, addedAdmins: addingAdmins } });
        dispatch(getClubOrganizers(clubId));
    } finally {
        dispatch({ type: 'SPLASH_HIDE' });
    }
};

export const inviteMembersToClub = membersList => async (dispatch, getState, { mainApi }) => {
    try {
        const { clubId } = getState().club;
        dispatch({ type: 'CLUBS:INVITE_CLUB_MEMBERS' });
        const result = await clubApis.inviteMembersToClub(mainApi, clubId, membersList);
        const { data } = result;
        if (data.error) {
            dispatch({ type: 'CLUBS:INVITE_CLUB_MEMBERS_FAILURE', data: { membersInvited: false } });
            dispatch(showErrorPopup({
                message: `Unable to invite members.`,
                error: data.error,
            }));
        } else {
            dispatch({ type: 'CLUBS:INVITE_CLUB_MEMBERS_SUCCESS', data: { data, membersInvited: true } });
            dispatch(getClubInvites());
        }
    } catch (err) {
        dispatch(showErrorPopup({
            message: `Unable to invite members.`,
            error: err,
        }));
        dispatch({ type: 'CLUBS:INVITE_CLUB_MEMBERS_FAILURE', data: { membersInvited: false } });
    }
};

export const getClubInvites = () => async (dispatch, getState, { mainApi }) => {
    try {
        const { clubId } = getState().club;
        dispatch({ type: 'CLUBS:GET_INVITES_REQUEST' });
        const result = await clubApis.getClubInvites(mainApi, clubId);
        const { data } = result;
        if (data.error) {
            dispatch({ type: 'CLUBS:GET_INVITES_FAILURE' });
        } else {
            dispatch({ type: 'CLUBS:GET_INVITES_SUCCESS', invites: data.data.invites });
        }
    } catch {
        dispatch({ type: 'CLUBS:GET_INVITES_FAILURE' });
    }
};

/* enterprise club add */
export const addMemberToClub = values => async (dispatch, getState, { mainApi }) => {
    try {
        const { clubId } = getState().club;
        dispatch({ type: 'CLUBS:ADD_CLUB_MEMBER_REQUEST' });
        const result = await clubApis.addMemberToClub(mainApi, clubId, values);
        const { data } = result;
        if (data.error) {
            dispatch({ type: 'CLUBS:ADD_CLUB_MEMBER_FAILURE', data });
            throw data.error;
        } else {
            dispatch(getClubMembers(clubId));

            // to get updated roster
            const { isHighSchool } = getState().club.clubDetails.tierType;
            if (isHighSchool) {
                dispatch(getClubSchoolDetails());
            }
        }
    } catch (err) {
        if (err.response) {
            dispatch(showErrorPopup({
                message: `Unable to add member.`,
                error: err,
            }));
        }
        throw err;
    }
};

function incrementAvailableMemberCount(property, value) {
    // if negative, infinite members case, so we do nothing
    if (property >= 0) {
        property = Math.max(0, property + value);
    }
    return property;
}

// this could get unwieldy if we add more roles
function updateMemberCount(clubDetails, fromRole, toRole) {
    switch (fromRole) {
        case 'Member':
            if (toRole === 'FormerMember') {
                clubDetails.availableMemberSlots = incrementAvailableMemberCount(clubDetails.availableMemberSlots, 1);
            }
            if (toRole === 'Owner') {
                clubDetails.availableOwnerSlots = incrementAvailableMemberCount(clubDetails.availableOwnerSlots, -1);
            }
            if (toRole === 'Admin') {
                clubDetails.availableAdminSlots = incrementAvailableMemberCount(clubDetails.availableAdminSlots, -1);
            }
            break;
        case 'Admin':
            if (toRole === 'FormerMember') {
                clubDetails.availableMemberSlots = incrementAvailableMemberCount(clubDetails.availableMemberSlots, 1);
                clubDetails.availableAdminSlots = incrementAvailableMemberCount(clubDetails.availableAdminSlots, 1);
            }
            if (toRole === 'Owner') {
                clubDetails.availableOwnerSlots = incrementAvailableMemberCount(clubDetails.availableOwnerSlots, -1);
                clubDetails.availableAdminSlots = incrementAvailableMemberCount(clubDetails.availableAdminSlots, 1);
            }
            if (toRole === 'Member') {
                clubDetails.availableAdminSlots = incrementAvailableMemberCount(clubDetails.availableAdminSlots, 1);
            }
            break;
        case 'Owner':
            if (toRole === 'FormerMember') {
                clubDetails.availableMemberSlots = incrementAvailableMemberCount(clubDetails.availableMemberSlots, 1);
                clubDetails.availableOwnerSlots = incrementAvailableMemberCount(clubDetails.availableOwnerSlots, 1);
            }
            if (toRole === 'Admin') {
                clubDetails.availableOwnerSlots = incrementAvailableMemberCount(clubDetails.availableOwnerSlots, 1);
                clubDetails.availableAdminSlots = incrementAvailableMemberCount(clubDetails.availableAdminSlots, -1);
            }
            if (toRole === 'Member') {
                clubDetails.availableOwnerSlots = incrementAvailableMemberCount(clubDetails.availableOwnerSlots, 1);
            }
            break;
        case 'FormerMember':
            clubDetails.availableMemberSlots = incrementAvailableMemberCount(clubDetails.availableMemberSlots, -1);
            if (toRole === 'Owner') {
                clubDetails.availableOwnerSlots = incrementAvailableMemberCount(clubDetails.availableOwnerSlots, -1);
            }
            if (toRole === 'Admin') {
                clubDetails.availableAdminSlots = incrementAvailableMemberCount(clubDetails.availableAdminSlots, -1);
            }
            break;
        default:
            break;
    }
}

export function updateMemberRole(memberId, memberRole) {
    return (dispatch, getState, { mainApi }) => {
        const { clubId, clubDetails, members } = getState().club;
        const { user } = getState().auth;
        dispatch({ type: 'CLUBS:UPDATE_MEMBER_ROLE' });
        clubApis.updateMemberRole(mainApi, clubId, memberId, memberRole)
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'CLUBS:UPDATE_MEMBER_ROLE_FAILURE' });
                } else {
                    const clubMemberIndex = _.findIndex(clubDetails.clubMembers, { memberId });
                    const membersIndex = _.findIndex(members, { memberId });
                    const formerMemberIndex = _.findIndex(clubDetails.formerClubMembers, { memberId });
                    if (data.role === 'FormerMember' || data.role === 'FormerFollower') {
                        if (clubMemberIndex !== -1 && clubDetails.clubMembers) {
                            const currentRole = clubDetails.clubMembers[clubMemberIndex].role;
                            updateMemberCount(clubDetails, currentRole, data.role);
                            // Delete object from members list
                            clubDetails.clubMembers.splice(clubMemberIndex, 1);
                        }
                        if (membersIndex !== -1 && members) {
                            // Delete object from members list
                            members.splice(membersIndex, 1);
                        }
                        if (formerMemberIndex !== -1) {
                            // Update object in former members list
                            clubDetails.formerClubMembers.splice(formerMemberIndex, 1, data);
                        } else {
                            // Add object in former members list
                            clubDetails.formerClubMembers.push(data);
                        }
                        dispatch({ type: CLUBS_UPDATE_FETCHSTATE, data: { deletedMembers: data } });
                    } else {
                        if (clubMemberIndex !== -1 && clubDetails.clubMembers) {
                            const currentRole = clubDetails.clubMembers[clubMemberIndex].role;
                            updateMemberCount(clubDetails, currentRole, data.role);
                            // Update object in members list
                            clubDetails.clubMembers.splice(clubMemberIndex, 1, data);
                        } else {
                            // Add object in members list
                            clubDetails.clubMembers.push(data);
                        }
                        if (membersIndex !== -1 && members) {
                            // Update object in members list
                            members.splice(membersIndex, 1, data);
                        } else {
                            // Add object in members list
                            members.push(data);
                        }
                        if (formerMemberIndex !== -1) {
                            const currentRole = clubDetails.formerClubMembers[formerMemberIndex].role;
                            updateMemberCount(clubDetails, currentRole, data.role);
                            // Delete object from former members list
                            clubDetails.formerClubMembers.splice(formerMemberIndex, 1);
                        }
                        dispatch({ type: CLUBS_UPDATE_FETCHSTATE, data: { updatedMembers: data } });

                        const clubOrganizerIndex = _.findIndex(clubDetails.clubOrganizers, { memberId });
                        if (data.role === 'Owner' || data.role === 'Admin') {
                            if (clubOrganizerIndex === -1) {
                                // add to organizer list
                                clubDetails.clubOrganizers.push(data);
                            } else {
                                // update organizer list
                                clubDetails.clubOrganizers.splice(clubOrganizerIndex, 1, data);
                            }
                        } else if (clubOrganizerIndex !== -1) {
                            // remove from organizer list
                            clubDetails.clubOrganizers.splice(clubOrganizerIndex, 1);
                        }
                    }
                    if (memberId === user.id) {
                        clubDetails.currentMember.role = data.role;
                    }
                    dispatch({
                        type: 'CLUBS:UPDATE_MEMBER_ROLE_SUCCESS',
                        data: { clubDetails, members },
                    });
                }
            })
            .catch(() => {
                dispatch({ type: 'CLUBS:UPDATE_MEMBER_ROLE_FAILURE' });
            });
    };
}

export function updateMemberType(memberId, isPhysicalMember) {
    return (dispatch, getState, { mainApi }) => {
        const { clubId, clubDetails, members } = getState().club;
        dispatch({ type: 'CLUBS:UPDATE_MEMBER_TYPE' });
        clubApis.updateMemberType(mainApi, clubId, memberId, isPhysicalMember)
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'CLUBS:UPDATE_MEMBER_TYPE_FAILURE' });
                } else {
                    const clubMember = _.find(clubDetails.clubMembers, { memberId });
                    const member = _.find(members, { memberId });
                    if (clubMember) {
                        clubMember.clubMemberTypeId = isPhysicalMember ? 1 : 2;
                        member.clubMemberTypeId = isPhysicalMember ? 1 : 2;
                    }
                    dispatch({
                        type: 'CLUBS:UPDATE_MEMBER_TYPE_SUCCESS',
                        data: { clubDetails, members },
                    });
                    dispatch({ type: CLUBS_UPDATE_FETCHSTATE, data: { updatedMembers: clubMember } });
                }
            })
            .catch(() => {
                dispatch({ type: 'CLUBS:UPDATE_MEMBER_TYPE_FAILURE' });
            });
    };
}

export function updateClubMemberPower(memberId, isPowerClub) {
    return (dispatch, getState, { mainApi }) => {
        const { clubId, clubDetails, members } = getState().club;
        dispatch({ type: 'CLUBS:UPDATE_MEMBER_POWER' });
        clubApis.updateClubMemberPower(mainApi, clubId, memberId, isPowerClub)
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'CLUBS:UPDATE_MEMBER_POWERE_FAILURE' });
                } else {
                    const clubMemberIndex = _.findIndex(clubDetails.clubMembers, { memberId });
                    const member = _.find(members, { memberId });
                    if (clubMemberIndex !== -1) {
                        clubDetails.clubMembers[clubMemberIndex] = data;
                        if (member) {
                            member.isPower = isPowerClub;
                        }
                        const isAdminOrOwner = data.role === 'Owner' || data.role === 'Admin';
                        if (!isAdminOrOwner) {
                            if (isPowerClub) {
                                clubDetails.currentPowerUsers += 1;
                            } else {
                                clubDetails.currentPowerUsers -= 1;
                            }
                        }
                    }
                    dispatch({
                        type: 'CLUBS:UPDATE_MEMBER_POWER_SUCCESS',
                        data: { clubDetails, members },
                    });
                    dispatch({ type: CLUBS_UPDATE_FETCHSTATE, data: { updatedMembers: data } });
                }
            })
            .catch(() => {
                dispatch({ type: 'CLUBS:UPDATE_MEMBER_POWER_FAILURE' });
            });
    };
}

export const getClubMembers = clubId => (dispatch, getState, { mainApi }) => {
    dispatch({ type: 'CLUBS:GET_MEMBERS' });
    clubApis.getClubMembers(mainApi, clubId)
        .then((result) => {
            const { data } = result;
            if (data.error) {
                dispatch({ type: 'CLUBS:GET_MEMBERS_FAILURE' });
            } else {
                dispatch({
                    type: 'CLUBS:GET_MEMBERS_SUCCESS',
                    data,
                });
            }
        })
        .catch(() => {
            dispatch({ type: 'CLUBS:GET_MEMBERS_FAILURE' });
        });
};

export const CLUBS_SEARCH_MEMBERS = 'CLUBS:SEARCH_MEMBERS';
export const CLUBS_SEARCH_MEMBERS_SUCCESS = 'CLUBS:SEARCH_MEMBERS_SUCCESS';
export const CLUBS_SEARCH_MEMBERS_FAILURE = 'CLUBS:SEARCH_MEMBERS_FAILURE';

export const searchClubMembers = (clubId, searchParams) => (dispatch, getState, { mainApi }) => {
    dispatch({ type: CLUBS_SEARCH_MEMBERS, searchParams });
    clubApis.searchClubMembers(mainApi, clubId, searchParams)
        .then((result) => {
            const { data } = result;
            if (data.error) {
                console.log('searchClubMembers error1', data.error);
                dispatch({ type: CLUBS_SEARCH_MEMBERS_FAILURE });
            } else {
                dispatch({
                    type: CLUBS_SEARCH_MEMBERS_SUCCESS,
                    data,
                });
            }
        })
        .catch((e) => {
            console.log('searchClubMembers error2', e);
            dispatch({ type: CLUBS_SEARCH_MEMBERS_FAILURE });
        });
};

export const CLUBS_GET_EVENTS = 'CLUBS:GET_EVENTS';
export const CLUBS_GET_EVENTS_SUCCESS = 'CLUBS:GET_EVENTS_SUCCESS';
export const CLUBS_GET_EVENTS_FAILURE = 'CLUBS:GET_EVENTS_FAILURE';

export const getClubEvents = clubId => (dispatch, getState, { mainApi }) => {
    dispatch({ type: CLUBS_GET_EVENTS });
    clubApis.getClubEvents(mainApi, clubId)
        .then((result) => {
            const { data } = result;
            if (data.error) {
                dispatch({
                    type: CLUBS_GET_EVENTS_FAILURE,
                });
            } else {
                dispatch({ type: CLUBS_GET_EVENTS_SUCCESS, data });
            }
        })
        .catch(() => {
            dispatch({
                type: CLUBS_GET_EVENTS_FAILURE,
            });
        });
};

export const CLUB_GET_SCHOOL_DETAILS = 'CLUBS:GET_SCHOOL_DETAILS';
export const CLUB_GET_SCHOOL_DETAILS_SUCCESS = 'CLUBS:GET_SCHOOL_DETAILS_SUCCESS';
export const CLUB_GET_SCHOOL_DETAILS_FAILURE = 'CLUBS:GET_SCHOOL_DETAILS_FAILURE';

export const getClubSchoolDetails = () => (dispatch, getState, { mainApi }) => {
    const { clubDetails, clubId } = getState().club;
    if (clubDetails.clubHasSchool) {
        dispatch({ type: CLUB_GET_SCHOOL_DETAILS });

        clubApis.getClubSchoolDetails(mainApi, clubId)
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: CLUB_GET_SCHOOL_DETAILS_FAILURE });
                    dispatch(showErrorPopup({
                        message: `Error loading club details.`,
                        error: data.error,
                    }));
                } else {
                    const schoolData = data;
                    const hasRosterLockFields = schoolData?.rosterId != null &&
                        !!schoolData?.locked &&
                        schoolData?.lockEndDate != null;

                    const schoolDetails = hasRosterLockFields
                        ? {
                            ...schoolData,
                            rosterId: schoolData.rosterId ?? null,
                            rosterCount: schoolData.rosterCount !== undefined
                                ? schoolData.rosterCount
                                : (schoolData?.roster?.length ?? 0),
                            locked: schoolData.locked,
                            lockEndDate: schoolData.lockEndDate,
                        }
                        : schoolData;

                    dispatch({
                        type: CLUB_GET_SCHOOL_DETAILS_SUCCESS,
                        data: {
                            schoolDetails,
                        },
                    });
                }
            })
            .catch((error) => {
                dispatch({
                    type: CLUB_GET_SCHOOL_DETAILS_FAILURE,
                });
                dispatch(showErrorPopup({
                    message: `Error loading club details.`,
                    error,
                }));
            });
    }
};

export function clearSplashProps() {
    return (dispatch) => {
        dispatch({ type: 'CLUBS:CLEAR_SPLASH_PROPS' });
    };
}
export const REQUEST_TO_JOIN = 'CLUBS:REQUEST_TO_JOIN';
export const REQUEST_TO_JOIN_SUCCESS = 'CLUBS:REQUEST_TO_JOIN_SUCCESS';
export const REQUEST_TO_JOIN_FAILURE = 'CLUBS:REQUEST_TO_JOIN_FAILURE';

export const requestToJoin = id => (dispatch, getState, { mainApi }) => {
    const { clubId, clubDetails } = getState().club;
    const { profile } = getState().dualMatch;
    const cludIdToUse = id || clubId;
    dispatch({ type: REQUEST_TO_JOIN });
    clubApis.requestToJoin(mainApi, cludIdToUse)
        .then((result) => {
            const { data } = result;
            if (data.error) {
                dispatch({ type: REQUEST_TO_JOIN_FAILURE });
            } else {
                let newClubDetails;
                // check and update in club reducer
                if (clubDetails && clubDetails.id.toString() === cludIdToUse) {
                    newClubDetails = _.cloneDeep(clubDetails);
                    newClubDetails.currentMember = data.currentMember;
                    if (data.clubMember) {
                        if (!_.isArray(newClubDetails.clubMembers)) {
                            newClubDetails.clubMembers = [];
                        }
                        newClubDetails.clubMembers.push(data.clubMember);
                    }
                    dispatch({ type: REQUEST_TO_JOIN_SUCCESS, data: { clubDetails: newClubDetails } });
                }
                // check and update in dual match reducer
                if (profile && ((profile.team1.clubId.toString() === cludIdToUse) || (profile.team2.clubId.toString() === cludIdToUse))) {
                    const newProfile = _.cloneDeep(profile);
                    if (profile.team1.clubId === cludIdToUse) {
                        newProfile.team1.currentMember = data.currentMember;
                    }
                    if (profile.team2.clubId === cludIdToUse) {
                        newProfile.team2.currentMember = data.currentMember;
                    }
                    dispatch({
                        type: 'DUALMATCH:UPDATE_MATCH_PROFILE',
                        data: { profile: newProfile },
                    });
                }
            }
        })
        .catch((error) => {
            dispatch({ type: 'CLUBS:REQUEST_TO_JOIN_FAILURE' });
            dispatch(showErrorPopup({
                message: `Request to join club Failed`,
                error,
            }));
        });
};

export const requestToUnfollow = id => (dispatch, getState, { mainApi }) => {
    const { clubId, clubDetails } = getState().club;
    const { profile } = getState().dualMatch;
    const cludIdToUse = id || clubId;
    const { user } = getState().auth;
    dispatch({ type: 'CLUBS:REQUEST_TO_UNFOLLOW' });
    clubApis.requestToUnfollow(mainApi, cludIdToUse)
        .then((result) => {
            const { data } = result;
            if (data.error) {
                dispatch({ type: 'CLUBS:REQUEST_TO_UNFOLLOW_FAILURE' });
            } else {
                // check and update in club reducer
                if (clubDetails && clubDetails.id.toString() === cludIdToUse) {
                    dispatch({ type: 'CLUBS:REQUEST_TO_UNFOLLOW_SUCCESS', data: { memberId: user.id } });
                }
                // check and update in dual match reducer
                if (profile && ((profile.team1.clubId.toString() === cludIdToUse) || (profile.team2.clubId === cludIdToUse))) {
                    const newProfile = _.cloneDeep(profile);
                    if (profile.team1.clubId === cludIdToUse) {
                        newProfile.team1.currentMember = {};
                    }
                    if (profile.team2.clubId === cludIdToUse) {
                        newProfile.team2.currentMember = {};
                    }
                    dispatch({
                        type: 'DUALMATCH:UPDATE_MATCH_PROFILE',
                        data: { profile: newProfile },
                    });
                }
            }
        })
        .catch((error) => {
            dispatch({ type: 'CLUBS:REQUEST_TO_UNFOLLOW_FAILURE' });
            dispatch(showErrorPopup({
                message: `Request to unfollow club failed`,
                error,
            }));
        });
};

export const approveOrRejectRequest = (value, requestObject) => (dispatch, getState, { mainApi }) => {
    const { clubId, clubDetails, members } = getState().club;
    dispatch({ type: 'CLUBS:ACCEPT_REJECT_REQUEST' });
    clubApis.approveOrRejectRequest(mainApi, clubId, requestObject.memberId, requestObject.id, value)
        .then((result) => {
            const { data } = result;
            if (data.error) {
                dispatch({ type: 'CLUBS:ACCEPT_REJECT_REQUEST_FAILURE' });
            } else {
                requestObject.acceptedRejectedDate = moment(new Date()).format('YYYY-MM-DD');
                if (value === 'accept') {
                    requestObject.status = 'Accepted';

                    const newObject = _.cloneDeep(requestObject);
                    newObject.initialJoinDate = moment(new Date()).format('YYYY-MM-DD');
                    newObject.role = 'Member';
                    clubDetails.clubMembers.push(newObject);
                    members.push(newObject);
                    const formerMemberIndex = _.findIndex(clubDetails.formerClubMembers, { memberId: newObject.memberId });
                    if (formerMemberIndex !== -1) {
                        clubDetails.formerClubMembers.splice(formerMemberIndex, 1);
                    }
                    incrementAvailableMemberCount(clubDetails.availableMemberSlots, -1);
                } else {
                    requestObject.status = 'Rejected';
                }

                dispatch({
                    type: 'CLUBS:ACCEPT_REJECT_REQUEST_SUCCESS',
                    data: { clubDetails, members },
                });
            }
        })
        .catch((error) => {
            dispatch({ type: 'CLUBS:ACCEPT_REJECT_REQUEST_FAILURE' });
            dispatch(showErrorPopup({
                message: `Something went wrong`,
                error,
            }));
        });
};

export const resendInvite = (value, clubId, invite) => (dispatch, getState, { mainApi }) => {
    const { clubId } = getState().club;
    dispatch({ type: 'CLUBS:RESEND_INVITE' });
    clubApis.resendInvite(mainApi, clubId, invite.id)
        .then((result) => {
            const { data } = result;
            if (data.error) {
                dispatch({ type: 'CLUBS:RESEND_INVITE_FAILURE' });
                dispatch(showErrorPopup({
                    error: `Resend Invite Failed`,
                }));
            } else {
                dispatch({ type: 'CLUBS:RESEND_INVITE_SUCCESS' });
                dispatch(showSuccessToast({
                    message: `Resend Invite Success`,
                }));
            }
        })
        .catch((error) => {
            dispatch({ type: 'CLUBS:RESEND_INVITE_FAILURE' });
            dispatch(showErrorPopup({
                message: `Resend Invite Failed`,
                error,
            }));
        });
};

export const deleteInvite = (value, clubId, invite) => (dispatch, getState, { mainApi }) => {
    const { clubId, clubDetails } = getState().club;
    dispatch({ type: 'CLUBS:DELETE_INVITE' });
    clubApis.deleteInvite(mainApi, clubId, invite.id)
        .then((result) => {
            const { data } = result;
            if (data.error) {
                dispatch({ type: 'CLUBS:DELETE_INVITE_FAILURE' });
                dispatch(showErrorPopup({
                    error: `Delete Invite Failed`,
                }));
            } else {
                _.remove(clubDetails.clubMemberInvites, clubMemberInvite => clubMemberInvite.id === invite.id);
                console.log(clubDetails);
                dispatch({ type: 'CLUBS:DELETE_INVITE_SUCCESS', data: { clubDetails } });
                dispatch(showSuccessToast({
                    message: `Delete Invite Success`,
                }));
            }
        })
        .catch((error) => {
            dispatch({ type: 'CLUBS:DELETE_INVITE_FAILURE' });
            dispatch(showErrorPopup({
                message: `Delete Invite Failed`,
                error,
            }));
        });
};

export const cropClubBanner = (clubId, values) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({
            type: 'CLUBS:CROP_BANNER_PHOTO',
        });
        const res = await submitClubBannerCrop(mainApi, clubId, values);
        dispatch({
            type: 'CLUBS:CROP_BANNER_PHOTO_SUCCESS',
            res,
        });
    } catch (err) {
        dispatch(showErrorPopup({
            message: `Error uploading image data`,
            error: err,
        }));
        throw err;
    }
};

export const removeBannerPhoto = clubId => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({
            type: 'CLUBS:REMOVE_BANNER_PHOTO',
        });
        const res = await removeClubBannerPhoto(mainApi, clubId);
        dispatch({
            type: 'CLUBS:REMOVE_BANNER_PHOTO_SUCCESS',
            res,
        });
    } catch (err) {
        dispatch(showErrorPopup({
            message: `Error removing club banner`,
            error: err,
        }));
        throw err;
    }
};

export const cropClubSponsorLogo = (clubId, values) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({
            type: 'CLUBS:CROP_SPONSOR_LOGO',
        });
        const res = await submitClubSponsorLogoCrop(mainApi, clubId, values);
        dispatch({
            type: 'CLUBS:CROP_SPONSOR_LOGO_SUCCESS',
            res,
        });
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error uploading image data.',
            error: err,
        }));
        throw err;
    }
};
export const cropEventSponsor = (clubId, values) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({
            type: 'EVENTS:CROP_SPONSOR_LOGO',
        });
        const res = await submitClubSponsorLogo(mainApi, clubId, values);

        dispatch({
            type: 'EVENTS:CROP_EVENT_SPONSOR_LOGO_SUCCESS',
            res,
        });

        return res;
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error uploading image data.',
            error: err,
        }));
        throw err;
    }
};
export const removeSponsorLogo = clubId => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({
            type: 'CLUBS:REMOVE_SPONSOR_LOGO',
        });
        const res = await removeClubSponsorLogo(mainApi, clubId);
        dispatch({
            type: 'CLUBS:REMOVE_SPONSOR_LOGO_SUCCESS',
            res,
        });
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error removing club sponsor logo.',
            error: err,
        }));
        throw err;
    }
};

export const applyForVerified = (clubId, autoApprove) => async (dispatch, getState, { mainApi }) => {
    if (autoApprove) {
        return dispatch(applyForAutoVerifyClub(clubId));
    }
    try {
        const res = await clubApis.applyForVerifiedClub(mainApi, clubId);
        dispatch({
            type: 'CLUBS:APPLY_FOR_VERIFIED_SUCCESS',
            res,
        });
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error submitting verified club application.',
            error: err,
        }));
        throw err;
    }
};

export const applyForAutoVerifyClub = clubId => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await clubApis.applyForAutoVerifyClub(mainApi, clubId);
        dispatch({
            type: 'CLUBS:APPLY_FOR_AUTO_VERIFIED_SUCCESS',
            res,
        });
        return true;
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error submitting verified club application.',
            error: err,
        }));
        throw err;
    }
};

export const addTeamRolesToClub = teamRolesList => async (dispatch, getState, { mainApi }) => {
    try {
        const { clubId } = getState().club;
        dispatch({ type: 'CLUB:ADD_TEAM_ROLES' });
        const result = await clubApis.addTeamRolesToClub(mainApi, clubId, teamRolesList);
        dispatch({ type: 'CLUB:ADD_TEAM_ROLES_SUCCESS', data: result.data });
    } catch (err) {
        dispatch({ type: 'CLUB:ADD_TEAM_ROLES_FAILURE' });
        dispatch(showErrorPopup({
            message: 'Error saving team roles.',
            error: err,
        }));
    }
};

export const addTeamTennisRolesToClub = teamRoles => async (dispatch, getState, { mainApi }) => {
    try {
        const { clubId } = getState().club;
        dispatch({ type: 'CLUB:ADD_TEAM_ROLES' });
        const result = await clubApis.addTeamTennisRole(mainApi, clubId, teamRoles);
        await dispatch({ type: 'CLUB:ADD_TEAM_ROLES_SUCCESS', data: result.data });
        await dispatch(getClubDetailsOnly());
    } catch (err) {
        dispatch({ type: 'CLUB:ADD_TEAM_ROLES_FAILURE' });
        dispatch(showErrorPopup({
            message: 'Error saving team roles.',
            error: err,
        }));
    }
};

export const removeTeamRoleFromClub = teamRoleId => async (dispatch, getState, { mainApi }) => {
    try {
        const { clubId, clubDetails } = getState().club;
        dispatch({ type: 'CLUB:REMOVE_TEAM_ROLE' });
        const result = await clubApis.removeTeamRoleFromClub(mainApi, clubId, teamRoleId);
        const { teamRoles } = clubDetails;
        _.remove(teamRoles, teamRole => teamRole.id === result.data.id);

        dispatch({ type: 'CLUB:REMOVE_TEAM_ROLE_SUCCESS', data: teamRoles });
    } catch (err) {
        dispatch({ type: 'CLUB:REMOVE_TEAM_ROLE_FAILURE' });
        dispatch(showErrorPopup({
            message: 'Error removing team roles.',
            error: err,
        }));
    }
};

export const removeTeamTennisRoleFromClub = teamRoleId => async (dispatch, getState, { mainApi }) => {
    try {
        const { clubId, clubDetails } = getState().club;
        dispatch({ type: 'CLUB:REMOVE_TEAM_ROLE' });
        await clubApis.removeTeamTennisRole(mainApi, clubId, teamRoleId);
        const { teamRoles } = clubDetails;
        _.remove(teamRoles, teamRole => teamRole.id === teamRoleId);

        dispatch({ type: 'CLUB:REMOVE_TEAM_ROLE_SUCCESS', data: teamRoles });
    } catch (err) {
        dispatch({ type: 'CLUB:REMOVE_TEAM_ROLE_FAILURE' });
        dispatch(showErrorPopup({
            message: 'Error removing team roles.',
            error: err,
        }));
    }
};

const getRosterId = (schoolDetails) => {
    return schoolDetails?.rosterId ?? null;
};

// Helper to build player payload for roster API
const buildPlayerPayload = (playerData) => {
    const payload = { playerId: playerData.playerId };

    if (playerData.classYearId !== null && playerData.classYearId !== undefined) {
        payload.classYearId = playerData.classYearId;
    }

    if (playerData.redshirt !== null && playerData.redshirt !== undefined) {
        payload.redshirt = playerData.redshirt;
    }

    return payload;
};

// Helper to add player using rosters API
const addPlayerViaRostersApi = async (dispatch, schoolDetails, playerData) => {
    const rosterId = getRosterId(schoolDetails);

    if (!rosterId) {
        dispatch({ type: CLUB_ADD_UPDATE_PLAYER_ON_ROSTER_FAILURE });
        dispatch(showErrorPopup({
            message: 'No roster found for this club',
        }));
        return;
    }

    const rostersApiAxiosInstance = getRostersApiAxiosInstance();
    const payload = buildPlayerPayload(playerData);

    // Add player API call - when this succeeds, popup can close
    const response = await rostersApi.addPlayerToRoster(rostersApiAxiosInstance, rosterId, payload);

    validateRosterApiResponse(response, dispatch, CLUB_ADD_UPDATE_PLAYER_ON_ROSTER_FAILURE);
    dispatch({ type: CLUB_ADD_UPDATE_PLAYER_ON_ROSTER_SUCCESS });
    dispatch(getClubSchoolDetails());
};

export const addPlayerToRoster = (playerData, checkGate, featureGates) => async (dispatch, getState, { mainApi }) => {
    try {
        const { clubId, schoolDetails, clubDetails } = getState().club;
        dispatch({ type: CLUB_ADD_UPDATE_PLAYER_ON_ROSTER });
        const isCollege = clubDetails?.tierType?.isCollege || false;
        const isNewRosterModel = isNewRosterModelEnabled(checkGate, featureGates, isCollege);

        if (isNewRosterModel && playerData.classYearId) {
            // Validate classYearId
            if (!isValidClassYearId(playerData.classYearId)) {
                dispatch({ type: CLUB_ADD_UPDATE_PLAYER_ON_ROSTER_FAILURE });
                dispatch(showErrorPopup({
                    message: `Invalid classYearId: ${playerData.classYearId}. Must be between 1 and 6.`,
                }));
                return;
            }

            await addPlayerViaRostersApi(dispatch, schoolDetails, playerData);
        } else {
            // Use old API endpoint
            const result = await clubApis.addPlayerToRoster(mainApi, clubId, playerData);
            dispatch({ type: CLUB_ADD_UPDATE_PLAYER_ON_ROSTER_SUCCESS, data: result.data });
        }
    } catch (err) {
        if (!err.response) {
            throw err;
        }

        dispatch({ type: CLUB_ADD_UPDATE_PLAYER_ON_ROSTER_FAILURE });

        // Extract error message from API response
        // Check for err.response.data.message (rosters-api format) or err.response.data.DisplayMessage (legacy format)
        const apiErrorMessage = err.response?.data?.message || err.response?.data?.DisplayMessage;
        const errorMessage = apiErrorMessage || 'Error adding player.';

        dispatch(showErrorPopup({
            message: errorMessage,
            error: err,
        }));

        // Re-throw the error so the calling component knows the operation failed
        // This prevents the success popup from showing
        throw err;
    }
};

// Helper to update player using rosters API
const updatePlayerViaRostersApi = async (dispatch, schoolDetails, playerData) => {
    const rosterId = getRosterId(schoolDetails);

    if (!rosterId) {
        dispatch({ type: CLUB_ADD_UPDATE_PLAYER_ON_ROSTER_FAILURE });
        dispatch(showErrorPopup({
            message: 'No roster found for this club',
        }));
        return;
    }

    const rostersApiAxiosInstance = getRostersApiAxiosInstance();
    const redshirtParam = playerData.redshirt !== undefined ? playerData.redshirt : undefined;

    const response = await rostersApi.updatePlayerClassYear(
        rostersApiAxiosInstance,
        rosterId,
        playerData.playerId,
        playerData.classYearId,
        redshirtParam,
    );
    validateRosterApiResponse(response, dispatch, CLUB_ADD_UPDATE_PLAYER_ON_ROSTER_FAILURE);

    // Use classYearStatus from API response (API handles redshirt prefix)
    const classYearStatus = response?.data?.data?.classYearStatus || getClassYearStatus(playerData.classYearId);

    // Extract redshirt status from response or playerData
    const apiRedshirtStatus = response?.data?.data?.redshirt;
    const redshirtStatus = apiRedshirtStatus !== undefined ? apiRedshirtStatus : playerData.redshirt;

    // Update player in the roster after success confirmed
    dispatch({
        type: 'CLUB:UPDATE_PLAYER_CLASS_YEAR_IN_ROSTER',
        playerId: playerData.playerId,
        classYearStatus,
        redshirt: redshirtStatus,
    });

    dispatch({ type: CLUB_ADD_UPDATE_PLAYER_ON_ROSTER_SUCCESS });
};

export const updatePlayer = (playerData, checkGate, featureGates) => async (dispatch, getState, { mainApi }) => {
    try {
        const { clubId, schoolDetails, clubDetails } = getState().club;
        dispatch({ type: CLUB_ADD_UPDATE_PLAYER_ON_ROSTER });
        const isCollege = clubDetails?.tierType?.isCollege || false;
        const isNewRosterModel = isNewRosterModelEnabled(checkGate, featureGates, isCollege);

        if (isNewRosterModel && playerData.classYearId) {
            // Validate classYearId
            if (!isValidClassYearId(playerData.classYearId)) {
                dispatch({ type: CLUB_ADD_UPDATE_PLAYER_ON_ROSTER_FAILURE });
                dispatch(showErrorPopup({
                    message: `Invalid classYearId: ${playerData.classYearId}. Must be between 1 and 6.`,
                }));
                return;
            }

            await updatePlayerViaRostersApi(dispatch, schoolDetails, playerData);
        } else {
            const result = await clubApis.updatePlayer(mainApi, clubId, playerData);
            dispatch({ type: CLUB_ADD_UPDATE_PLAYER_ON_ROSTER_SUCCESS, data: result.data });
        }
    } catch (err) {
        if (!err.response) {
            throw err;
        }

        dispatch({ type: CLUB_ADD_UPDATE_PLAYER_ON_ROSTER_FAILURE });
        dispatch(showErrorPopup({
            message: 'Error updating player.',
            error: err,
        }));
    }
};

export const removePlayerFromRoster = (playerId, checkGate, featureGates) => async (dispatch, getState, { mainApi }) => {
    try {
        const { clubId, schoolDetails, clubDetails } = getState().club;
        dispatch({ type: CLUB_REMOVE_PLAYER_FROM_ROSTER });
        const isCollege = clubDetails?.tierType?.isCollege || false;
        const isNewRosterModel = isNewRosterModelEnabled(checkGate, featureGates, isCollege);

        if (isNewRosterModel) {
            // Use new rosters API endpoint
            // Get rosterId from schoolDetails or fetch it if not available
            const rosterId = getRosterId(schoolDetails);

            if (!rosterId) {
                dispatch({ type: CLUB_REMOVE_PLAYER_FROM_ROSTER_FAILURE });
                dispatch(showErrorPopup({
                    message: 'No roster found for this club',
                }));
                return;
            }

            const rostersApiAxiosInstance = getRostersApiAxiosInstance();
            const response = await rostersApi.removePlayerFromRoster(rostersApiAxiosInstance, rosterId, playerId);

            validateRosterApiResponse(response, dispatch, CLUB_REMOVE_PLAYER_FROM_ROSTER_FAILURE);
            dispatch({
                type: CLUB_REMOVE_PLAYER_FROM_ROSTER_OPTIMISTIC,
                playerId,
            });

            dispatch({ type: CLUB_REMOVE_PLAYER_FROM_ROSTER_SUCCESS });
        } else {
            // Use old API endpoint
            const result = await clubApis.removePlayerFromRoster(mainApi, clubId, playerId);
            const { roster } = schoolDetails;
            _.remove(roster, player => player.id === result.data.id);

            dispatch({ type: CLUB_REMOVE_PLAYER_FROM_ROSTER_SUCCESS, data: roster });
        }
    } catch (err) {
        if (!err.response) {
            throw err;
        }

        dispatch({ type: CLUB_REMOVE_PLAYER_FROM_ROSTER_FAILURE });
        dispatch(showErrorPopup({
            message: 'Error removing player from roster.',
            error: err,
        }));
    }
};

const dispatchRedshirtFailure = (dispatch, message) => {
    dispatch({ type: CLUB_SET_PLAYER_REDSHIRT_STATUS_FAILURE });
    dispatch(showErrorPopup({ message }));
};

const getRedshirtValidationError = (isNewRosterModel, playerData) => {
    if (!isNewRosterModel) { return 'Redshirt status is only available for rosters rollout feature'; }
    if (playerData.classYearId && !isValidClassYearId(playerData.classYearId)) {
        return `Invalid classYearId: ${playerData.classYearId}. Must be between 1 and 6.`;
    }
    return null;
};

export const setPlayerRedshirtStatus = (playerData, checkGate, featureGates) => async (dispatch, getState) => {
    try {
        const { schoolDetails, clubDetails } = getState().club;
        dispatch({ type: CLUB_SET_PLAYER_REDSHIRT_STATUS });
        const isCollege = clubDetails?.tierType?.isCollege || false;
        const isNewRosterModel = isNewRosterModelEnabled(checkGate, featureGates, isCollege);

        const validationError = getRedshirtValidationError(isNewRosterModel, playerData);
        if (validationError) {
            dispatchRedshirtFailure(dispatch, validationError);
            return;
        }

        const rosterId = getRosterId(schoolDetails);

        if (!rosterId) {
            dispatchRedshirtFailure(dispatch, 'No roster found for this club');
            return;
        }

        const rostersApiAxiosInstance = getRostersApiAxiosInstance();

        // If classYearId is provided, update both class year and redshirt status
        // Otherwise, just update redshirt status (send only redshirt in payload)
        // Ensure playerId is a number
        const playerId = typeof playerData.playerId === 'string' ? parseInt(playerData.playerId, 10) : playerData.playerId;

        if (playerData.classYearId) {
            // Update both classYearId and redshirt - send both in payload
            const response = await rostersApi.updatePlayerClassYear(
                rostersApiAxiosInstance,
                rosterId,
                playerId,
                playerData.classYearId,
                playerData.redshirt,
            );
            validateRosterApiResponse(response, dispatch, CLUB_SET_PLAYER_REDSHIRT_STATUS_FAILURE);

            // Use classYearStatus from API response (API handles redshirt prefix)
            const classYearStatus = response?.data?.data?.classYearStatus || getClassYearStatus(playerData.classYearId);
            const redshirtStatus = response?.data?.data?.redshirt ?? playerData.redshirt;

            dispatch({
                type: CLUB_UPDATE_PLAYER_REDSHIRT_STATUS_IN_ROSTER,
                playerId: playerData.playerId,
                classYearStatus,
                redshirt: redshirtStatus,
            });
        } else {
            // Just update redshirt status - send only redshirt in payload (no classYearId)
            const response = await rostersApi.updatePlayerClassYear(
                rostersApiAxiosInstance,
                rosterId,
                playerId, // Use parsed playerId
                undefined, // Don't send classYearId
                playerData.redshirt, // Only send redshirt
            );
            validateRosterApiResponse(response, dispatch, CLUB_SET_PLAYER_REDSHIRT_STATUS_FAILURE);

            // Get current player to preserve classYearStatus
            const player = (schoolDetails?.roster || []).find((p) => p.id === playerData.playerId);

            if (!player) {
                dispatch({ type: CLUB_SET_PLAYER_REDSHIRT_STATUS_FAILURE });
                dispatch(showErrorPopup({
                    message: 'Player not found in roster',
                }));
                return;
            }

            // Use classYearStatus from API response or preserve current
            const classYearStatus = response?.data?.data?.classYearStatus || player.classYearStatus;
            const redshirtStatus = response?.data?.data?.redshirt ?? playerData.redshirt;

            dispatch({
                type: CLUB_UPDATE_PLAYER_REDSHIRT_STATUS_IN_ROSTER,
                playerId: playerData.playerId,
                classYearStatus,
                redshirt: redshirtStatus,
            });
        }

        dispatch({ type: CLUB_SET_PLAYER_REDSHIRT_STATUS_SUCCESS });
    } catch (err) {
        if (!err.response) {
            throw err;
        }

        dispatch({ type: CLUB_SET_PLAYER_REDSHIRT_STATUS_FAILURE });
        dispatch(showErrorPopup({
            message: 'Error updating redshirt status.',
            error: err,
        }));
    }
};

export const cropClubProfilePhoto = (clubId, values) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await submitClubProfilePhotoCrop(mainApi, clubId, values);
        dispatch({
            type: 'CLUBS:CROP_PROFILE_PHOTO_SUCCESS',
            res,
        });
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error uploading image data.',
            error: err,
        }));
        throw err;
    }
};

export const removeProfilePhoto = clubId => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await removeClubProfilePhoto(mainApi, clubId);
        dispatch({
            type: 'CLUBS:REMOVE_PROFILE_PHOTO_SUCCESS',
            res,
        });
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error removing club profile photo.',
            error: err,
        }));
        throw err;
    }
};

export function getClubResults(initialFetch) {
    return (dispatch, getState, { mainApi }) => {
        const { clubId, resultsFetchState, clubDetails, resultsType, results } = getState().club;
        const start = initialFetch ? 0 : resultsFetchState.totalResultsFetched;
        const { count } = resultsFetchState;
        if (start >= clubDetails.resultCount) {
            return;
        }
        dispatch({
            type: 'CLUBS:FETCH_RESULTS_REQUEST',
            data: {
                clubId,
            },
        });
        clubApis.fetchClubResults(mainApi, { resultsType, start, count }, clubId)
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'CLUBS:FETCH_RESULTS_FAILURE' });
                } else {
                    let tempResults;
                    if (initialFetch) {
                        tempResults = data;
                    } else {
                        tempResults = {
                            events: results.events.concat(data.events),
                        };
                    }
                    const totalResultsFetched = tempResults.events.reduce((count, event) => count + event.draws.reduce((count2, draw) => count2 + draw.results.length, 0) + event.results.length, 0);
                    dispatch({
                        type: 'CLUBS:FETCH_RESULTS_SUCCESS',
                        data: {
                            results: tempResults,
                            start,
                            count,
                            totalResultsFetched,
                        },
                    });
                }
            })
            .catch(() => {
                dispatch({ type: 'CLUBS:FETCH_RESULTS_FAILURE' });
            });
    };
}

export function changeResultsType(resultsType) {
    return (dispatch) => {
        dispatch({ type: 'CLUBS:CHANGE_RESULT_TYPE', resultsType });
        dispatch(getClubResults(true));
    };
}

export const getClubMetaData = clubId => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await clubApis.clubMeta(mainApi, clubId);
        if (res.data.error) {
            console.log('ERROR GETTING CLUB META DATA', res.data.error);
        } else {
            dispatch({
                type: 'CLUBS:META_FETCH_SUCCESS',
                data: res.data,
            });
        }
    } catch (error) {
        console.log('ERROR GETTING CLUB META DATA 2', error);
    }
};

export const sendMessageToMembers = (message, clubId) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: 'CLUBS:SEND_MESSAGE_TO_MEMBERS' });
    try {
        const res = await clubApis.sendMessage(mainApi, message, clubId);
        if (res.data.error) {
            dispatch({ type: 'CLUBS:SEND_MESSAGE_TO_MEMBERS_FAILURE' });
            dispatch(showErrorPopup({
                message: 'Error Sending Message',
                error: res.data.error,
            }));
        } else {
            dispatch({ type: 'CLUBS:SEND_MESSAGE_TO_MEMBERS_SUCCESS' });
            dispatch(showSuccessToast({
                message: `Message Sent`,
            }));
        }
    } catch (error) {
        dispatch({ type: 'CLUBS:SEND_MESSAGE_TO_MEMBERS_FAILURE' });
        dispatch(showErrorPopup({
            message: 'Error Sending Message',
            error,
        }));
    }
};

export function getPower6Stats({ conferenceId, gender }) {
    return (dispatch, getState, { mainApi }) => {
        dispatch({
            type: 'CLUBS:FETCH_POWER6_STATS',
            data: {
                conferenceId,
                gender,
            },
        });
        clubApis.power6Stats(mainApi, conferenceId, gender)
            .then((result) => {
                const { data } = result;
                dispatch({
                    type: 'CLUBS:FETCH_POWER6_STATS_SUCCESS',
                    data: {
                        stats: data,
                    },
                });
            })
            .catch(() => {
                dispatch({ type: 'CLUBS:FETCH_POWER6_STATS_FAILURE' });
            });
    };
}

export const CLUBS_REMOVE_MEMBERS = 'CLUBS:REMOVE_MEMBERS';
export const CLUBS_REMOVE_MEMBERS_FAILURE = 'CLUBS:REMOVE_MEMBERS_FAILURE';
export const CLUBS_UPDATE_FETCHSTATE = 'CLUBS:UPDATE_FETCHSTATE';

export const removeClubMembers = (clubId, payload) => (dispatch, getState, { mainApi }) => {
    console.log('removeClubMembers', clubId, payload);
    dispatch({ type: CLUBS_REMOVE_MEMBERS });
    clubApis.removeClubMembers(mainApi, clubId, payload)
        .then((res) => {
            console.log('removeClubMembers res', res);
            const { data } = res;
            if (data.error) {
                dispatch({ type: CLUBS_REMOVE_MEMBERS_FAILURE });
                dispatch(showErrorPopup({
                    error: 'Error Removing Members',
                }));
            } else {
                dispatch({ type: CLUBS_UPDATE_FETCHSTATE, data: { deletedMembers: data } });
                const { clubMembersFetchState } = getState().club;
                dispatch(searchClubMembers(clubId, clubMembersFetchState.searchParams));
                // clear member select checkboxes
                dispatch(updateMemberSelection());
            }
        })
        .catch(() => {
            dispatch({ type: CLUBS_REMOVE_MEMBERS_FAILURE });
            dispatch(showErrorPopup({
                error: 'Error Removing Members',
            }));
        });
};

export const CLUBS_CHANGE_MEMBERSHIP_TYPE = 'CLUBS:CHANGE_MEMBERSHIP_TYPE';
export const CLUBS_CHANGE_MEMBERSHIP_TYPE_FAILURE = 'CLUBS:CHANGE_MEMBERSHIP_TYPE_FAILURE';

export const changeMembershipType = (clubId, payload) => (dispatch, getState, { mainApi }) => {
    console.log('changeMembershipType', clubId, payload);
    dispatch({ type: CLUBS_CHANGE_MEMBERSHIP_TYPE });
    clubApis.changeMembershipType(mainApi, clubId, payload)
        .then((res) => {
            console.log('changeMembershipType res', res);
            const { data } = res;
            if (data.error) {
                dispatch({ type: CLUBS_CHANGE_MEMBERSHIP_TYPE_FAILURE });
                dispatch(showErrorPopup({
                    message: 'Error Changing Membership Type',
                    error: data.error,
                }));
            } else {
                dispatch({ type: CLUBS_UPDATE_FETCHSTATE, data: { updatedMembers: data } });
                const { clubMembersFetchState } = getState().club;
                dispatch(searchClubMembers(clubId, clubMembersFetchState.searchParams));
                // clear member select checkboxes
                dispatch(updateMemberSelection());
            }
        })
        .catch((err) => {
            dispatch({ type: CLUBS_CHANGE_MEMBERSHIP_TYPE_FAILURE });
            dispatch(showErrorPopup({
                message: 'Error Changing Membership Type',
                error: err,
            }));
        });
};

export const CLUBS_UPDATE_MEMBER_SELECTION = 'CLUBS:UPDATE_MEMBER_SELECTION';
export const updateMemberSelection = (selectionArrays) => (dispatch) => {
    dispatch({ type: CLUBS_UPDATE_MEMBER_SELECTION, ...selectionArrays });
};

export const CLUBS_GET_ORGANIZERS = 'CLUBS:FETCH_ORGANIZERS';
export const CLUBS_GET_ORGANIZERS_SUCCESS = 'CLUBS:FETCH_ORGANIZERS_SUCCESS';
export const CLUBS_GET_ORGANIZERS_FAILURE = 'CLUBS:FETCH_ORGANIZERS_FAILURE';
export const getClubOrganizers = (clubId) => (dispatch, getState, { mainApi }) => {
    dispatch({ type: CLUBS_GET_ORGANIZERS });
    clubApis.getClubOrganizers(mainApi, clubId)
        .then((result) => {
            const { data } = result;
            if (data.error) {
                console.log('getClubOrganizers error1');
                dispatch({ type: CLUBS_GET_ORGANIZERS_FAILURE });
            } else {
                dispatch({
                    type: CLUBS_GET_ORGANIZERS_SUCCESS,
                    data,
                });
            }
        })
        .catch(() => {
            console.log('getClubOrganizers error2');
            dispatch({ type: CLUBS_GET_ORGANIZERS_FAILURE });
        });
};

export function getHighSchoolStandingsSeasons({ clubId }) {
    return (dispatch, getState, { mainApi }) => {
        dispatch({
            type: CLUBS_FETCH_HIGHSCHOOL_STANDINGS_SEASONS,
        });
        clubApis.highSchoolStandingsSeasons(mainApi, clubId)
            .then((result) => {
                const { data } = result;

                // Adding current year to season if no event published after jul 15
                const currentYear = new Date().getFullYear();
                const isCurrentSeason = hasCurrentSeasonStarted();

                const seasons = isCurrentSeason && !data?.some(x => x === currentYear) ? [currentYear, ...data] : data;

                dispatch({
                    type: CLUBS_FETCH_HIGHSCHOOL_STANDINGS_SEASONS_SUCCESS,
                    data: {
                        highSchoolStandingsSeasons: seasons,
                    },
                });
            })
            .catch(() => {
                dispatch({ type: CLUBS_FETCH_HIGHSCHOOL_STANDINGS_SEASONS_FAILURE });
            });
    };
}

export function getHighSchoolStandings({ clubId, seasonYear }) {
    return (dispatch, getState, { mainApi }) => {
        dispatch({
            type: CLUBS_FETCH_HIGHSCHOOL_STANDINGS,
        });
        clubApis.highSchoolStandings(mainApi, clubId, seasonYear)
            .then((result) => {
                const { data } = result;
                dispatch({
                    type: CLUBS_FETCH_HIGHSCHOOL_STANDINGS_SUCCESS,
                    data: {
                        highSchoolStandings: data,
                    },
                });
            })
            .catch(() => {
                dispatch({ type: CLUBS_FETCH_HIGHSCHOOL_STANDINGS_FAILURE });
            });
    };
}

export const getAdultTeamTennisStandings = ({ clubId }) => async (dispatch, getState, { mainApi }) => {
    dispatch({
        type: 'CLUBS_FETCH_ADULT_TEAMTENNIS_STANDINGS',
    });
    const result = await clubApis.getAdultTeamTennisStandings(mainApi, clubId);
    const { data } = result;

    if (data.error) {
        dispatch({
            type: 'CLUBS_FETCH_ADULT_TEAMTENNIS_STANDINGS_FAILURE',
            data: data.error,
        });
    } else {
        dispatch({
            type: 'CLUBS_FETCH_ADULT_TEAMTENNIS_STANDINGS_SUCCESS',
            data: {
                adultTeamTennisStandings: data,
            },
        });
    }
};
export const includeInAttStandings = (eventId) => async (dispatch, getState, { mainApi }) => {
    const { clubId } = getState().club;

    dispatch({ type: 'CLUBS_INCLUDE_IN_ATT_STANDINGS_REQUEST' });
    try {
        const res = await clubApis.includeInAttStandings(mainApi, eventId);
        if (res.data.error) {
            dispatch({ type: 'CLUBS_INCLUDE_IN_ATT_STANDINGS_FAILURE', res });
        } else {
            await dispatch({ type: 'CLUBS_INCLUDE_IN_ATT_STANDINGS_SUCCESS', eventId });
            dispatch(getAdultTeamTennisStandings({ clubId }));
            return res.data;
        }
    } catch (error) {
        dispatch({ type: 'CLUBS_INCLUDE_IN_ATT_STANDINGS_FAILURE' });
        dispatch(showErrorPopup({
            message: 'Error including event in standings',
            error,
        }));
    }
};

export const omitFromAttStandings = (eventId) => async (dispatch, getState, { mainApi }) => {
    const { clubId } = getState().club;
    dispatch({ type: 'CLUBS_OMIT_FROM_ATT_STANDINGS_REQUEST' });
    try {
        const res = await clubApis.omitFromAttStandings(mainApi, eventId);
        if (res.data.error) {
            dispatch({ type: 'CLUBS_OMIT_FROM_ATT_STANDINGS_FAILURE', res });
        } else {
            await dispatch({ type: 'CLUBS_OMIT_FROM_ATT_STANDINGS_SUCCESS', eventId });
            dispatch(getAdultTeamTennisStandings({ clubId }));
            return res.data;
        }
    } catch (error) {
        dispatch({ type: 'CLUBS_OMIT_FROM_ATT_STANDINGS_FAILURE' });
        dispatch(showErrorPopup({
            message: 'Error omitting event from standings',
            error,
        }));
    }
};
export const getAdultTeamTennisClubRoster = ({ clubId }) => async (dispatch, getState, { mainApi }) => {
    dispatch({
        type: 'CLUBS_FETCH_ADULT_TEAMTENNIS_ROSTER',
    });
    const result = await clubApis.getAdultTeamTennisRoster(mainApi, clubId);
    const { data } = result;
    if (data.error) {
        dispatch({
            type: 'CLUBS_FETCH_ADULT_TEAMTENNIS_ROSTER_FAILURE',
            data: data.error,
        });
    } else {
        const structuredAdultTeamTennisRoster = data.players.map(player => {
            return {
                ...player,
                myUtrSingles: player.unverifiedSinglesUtr,
                myUtrDoubles: player.unverifiedDoublesUtr,
                singlesUtr: player.verifiedSinglesUtr,
                doublesUtr: player.verifiedDoublesUtr,
                id: player.playerId,
                playerProfileImages: player.profileImages,
            };
        });
        dispatch({
            type: 'CLUBS_FETCH_ADULT_TEAMTENNIS_ROSTER_SUCCESS',
            data: {
                roster: structuredAdultTeamTennisRoster,
            },
        });
    }
};

export const getAdultTeamTennisEvents = ({ clubId }) => async (dispatch, getState, { mainApi }) => {
    dispatch({
        type: 'CLUBS_FETCH_ADULT_TEAMTENNIS_EVENTS',
    });
    const result = await clubApis.getAdultTeamTennisEvents(mainApi, clubId);
    const { data } = result;
    const structuredTeamEvents = data.events.map(event => {
        return {
            ...event,
            eventSchedule: {
                eventStartDate: event.startDate,
                eventEndDate: event.endDate,
            },
            team1: {
                ...event.team1,
                shortName: event.team1.name,
            },
            team2: {
                ...event.team2,
                shortName: event.team2.name,
            },
        };
    });

    if (data.error) {
        dispatch({
            type: 'CLUBS_FETCH_ADULT_TEAMTENNIS_EVENTS_FAILURE',
            data: data.error,
        });
    } else {
        dispatch({
            type: 'CLUBS_FETCH_ADULT_TEAMTENNIS_EVENTS_SUCCESS',
            data: structuredTeamEvents,
        });
    }
};

export const getClubTeamRating = (clubId, snapshotDateLabel) => async (dispatch, getState, { mainApi }) => {
    dispatch({
        type: 'CLUBS_FETCH_CLUB_TEAM_RATINGS',
    });

    const result = await clubApis.getClubTeamRatingsByClubId(mainApi, clubId, snapshotDateLabel);
    const { data } = result;

    if (data.error) {
        dispatch({
            type: 'CLUBS_FETCH_CLUB_TEAM_RATINGS_FAILURE',
            data: data.error,
        });
    } else {
        dispatch({
            type: 'CLUBS_FETCH_CLUB_TEAM_RATINGS_SUCCESS',
            data,
        });
    }
};
